var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row filter-wrap"},[_c('div',{staticClass:"col"},[_c('filter-block',{attrs:{"details":"true"},on:{"updateFinance":function($event){return _vm.update()}}}),_c('finance-details')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }